import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { RedirectDialogComponent } from 'src/app/components/redirect/redirect-dialog/redirect-dialog.component';
import { RedirectService } from 'src/app/components/redirect/redirect.service';

export interface IRedirectGuard {
  redirectTo: boolean | Observable<boolean>;
}

@Injectable({
  providedIn: 'root'
})
export class RedirectGuard implements CanDeactivate<IRedirectGuard> {

  constructor(
    public dialog: MatDialog,
    private redirect: RedirectService
  ) {

  }

  /**
   * Allows marked document redirects to continue in the current tab.
   * @param component Component being deactivated.
   * @param currentRoute Current activated route snapshot.
   * @param currentState Current router state.
   * @param nextState Target router state.
   */
  async canDeactivate(component: IRedirectGuard, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot): Promise<boolean | UrlTree> {
    if (this.isSameTabRedirect(nextState.url)) {
      // Marked document links always continue in the same tab.
      localStorage.setItem('currentUrl', nextState.url);
      this.removeLocalStorageUrl();
      return true;
    }

    if (component.redirectTo || !nextState.url.includes('/redirect/') || localStorage.getItem('currentUrl') == nextState.url) {
      localStorage.setItem('currentUrl', nextState.url);
      this.removeLocalStorageUrl();
      return true;
    } else {
      localStorage.setItem('currentUrl', nextState.url);
      const redirectUrl = localStorage.getItem('redirect-route');
      if (!redirectUrl) {
        // Show the dialog and return an observable based on user's response
        const dialogRef = this.dialog.open(RedirectDialogComponent, {
          disableClose: false,
          backdropClass: 'transparent-backdrop',
          data: { targetUrl: nextState.url },
          position: {
            left: this.redirect.mouseX ?? '',
            top: this.redirect.mouseY ?? '',
          },
        });

        const response = await dialogRef.afterClosed().toPromise().then(data => {
          return false;
        });
        this.removeLocalStorageUrl();
        return response;
      }
      return true;
    }
  }

  /**
   * Detects redirect links that explicitly request the current browser tab.
   * @param url Target router URL.
   */
  private isSameTabRedirect(url: string): boolean {
    return url.includes('/redirect/') && url.includes('redirectMode=same-tab');
  }

  removeLocalStorageUrl() {
    setTimeout(() => {
      localStorage.removeItem('currentUrl');
      localStorage.removeItem('redirect-route');
    }, 3000);
  }
}
